/**
动态表单结构体转换工具类
ver 1.0.0
修改记录：
  2018-8-1：
*/
import templateUtil from './templateUtil'
import compileVariableUtil from './compileVariableUtil'
import converterUtil from './converterUtil'

let createFormConverterUtil = {}

/**
动态表单配置优化：部分输入组件类型必须强制未独占一行，目前是通过不配置标题来控制的。修改为不通过标题配置，强制代码控制：这类组件有：'crudArray', 'editInTable',
  'groupBlank', 'groupDashed'
隐藏标题的输入类型。目标时title控制了是否生成 FormItem 。
目的不生成FormItem 强制换行。
*/
createFormConverterUtil.HiddenTitleType = [
  'crudArray',
  'crudArrayOrder',
  'realPageTable',
  'addressInfoDetail',
  'editInTable',
  'flashAddMedical',
  'groupBlank',
  'groupDashed',
  'partitionErect',
]
/**
 特殊协议转换适配器，定义类。
 属性名使用 组件类型。
 groupLabel：特殊转换器，1.显示名优先注入到标题。2.支持锚点提取
*/
createFormConverterUtil.converterAdapter = {
  // "DatePicker": (item, data) => {
  //   item.type = "panguDatePicker";
  // },

  radio: (item) => {
    if (!item) return

    if ((item.props && item.props.options) || item.options) {
      if (!item.props) item.props = {}
      item.props.source = item.props.options || item.options

      if (item.props.options) {
        item.props.source = item.props.options
        delete item.props.options
      } else if (item.options) {
        item.props.source = item.options
      }

      delete item.props.options
      if (!item.props.optionValue) item.props.optionValue = 'value'
      if (!item.props.optionLabel) item.props.optionLabel = 'label'
      item.props.remote = false
      item.props.isBoolean = true
    }

    // console.log("createFormConverterUtil.converterAdapter.radio", item);
  },

  select: (item) => {
    // console.log("createFormConverterUtil.converterAdapter.select", item);
    if (!item.props) item.props = {}
    //反向兼容 fromcreate （item.options）结构体。
    if (item.options && !item.props.options) {
      item.props.options = item.options
    }
    // console.log("createFormConverterUtil.converterAdapter.select", item);
  },
  //特殊转换器，1.显示名优先注入到标题。2.支持锚点提取
  groupLabel: (item, data) => {
    if (!item) return

    //兼容后台只配置显示名
    if (item.title) {
      if (!item.props) item.props = {}
      item.props.title = item.title
      item.title = null
    }

    if (item.props && item.props.id) {
      var anchor = {
        href: '#' + item.props.id,
        title: item.props.title,
      }
      if (data.anchorList) data.anchorList.push(anchor)
    }
  },

  datepicker: (item) => {
    if (!item) return
    if (!item.props) item.props = {}
    if (!item.props.type) {
      item.props.type = 'date'
    }

    if (item.props.type == 'datetime') {
      if (!item.props.format) item.props.format = 'yyyy-MM-dd HH:mm:ss'
    } else if (item.props.type == 'date') {
      if (!item.props.format) item.props.format = 'yyyy-MM-dd'
    }
  },
}
createFormConverterUtil.converterAdapter['checkbox'] =
  createFormConverterUtil.converterAdapter['radio']

/**
 特殊协议转换适配器，定义类。
 属性名使用 组件类型。
 设置输入框宽度
*/
let neddSetArr = ['input', 'select', 'selectRemote', 'readText']
createFormConverterUtil.converterAdapterOfForStyle = {
  //特殊转换器，设置输入框宽度
  setWidth: (item, data) => {
    if (!item) return
    if (!item.typeCode) return
    if (!item.type || neddSetArr.indexOf(item.type) == -1) return
    //设置input的maxlength
    if (item.type == 'input') {
      if (!item.props) {
        item.props = {}
      }
      if (item.props.maxlength) return
      if (item.typeCode == 'STRING_L1') {
        item.props.maxlength = 50
      } else if (item.typeCode == 'STRING_L2') {
        item.props.maxlength = 100
      } else if (item.typeCode == 'STRING_L3') {
        item.props.maxlength = 400
      }
    }

    if (
      !data ||
      !data.form ||
      !data.form.property ||
      !data.form.property.props ||
      data.form.property.props.inline !== false
    )
      return

    if (!item.style) {
      item.style = {}
    }
    if (item.style.width) return

    if (item.typeCode == 'STRING_L1') {
      item.style.width = '100px'
    } else if (item.typeCode == 'STRING_L2') {
      item.style.width = '200px'
    } else if (item.typeCode == 'STRING_L3') {
      item.style.width = '440px'
    }
  },
}

/**
 * 将盘谷后台定义动态表单结构体转换成 form-create 要求的结构体
 * @param {object} data scc后台定义结构体
 @param {boolean} disabled 所有组件是否设置为只读模式

 * @return {object} data 转换成form-create 要求的结构体

 */
createFormConverterUtil.converterByDictFormData = function (data, disabled, strategy) {
  if (!data) return data
  //锚点列表
  if (!data.anchorList) data.anchorList = []

  this.converterItems(data.items, data, disabled, strategy)
  return data
}

/**

*/
/**
 *   根据数据类型强制转换输入组件，才能使 验证表达式生效。
 * @param {object} item scc后台定义结构体的元素
 * @param {object} data scc后台定义结构体
 @param {boolean} disabled 所有组件是否设置为只读模式

 */
createFormConverterUtil.converterDataTypeDefinition = function (item) {
  //数字类型强制转换输入组件，才能使 验证表达式生效。
  // if (!item.component) item.component = {};
  // if (!item.type) item.type = {};

  if (!item.type || !item.type.code) {
    return
  }
  if (!item.component || item.component.code == 'readText') {
    return
  }

  var numberTypeArray = ['FLOAT', 'DOUBLE', 'DECIMAL', 'MONEY', 'LONG', 'INTEGER']

  if (numberTypeArray.indexOf(item.type.code) > -1 && item.component.code == 'input') {
    item.component.code = 'inputNumber'
  }
  if (item.component.code == 'inputNumber') {
    item.component.code = 'panguInputNumber'
  }
}

/**
 * 将每个定义表单输入控件，转换成组件要求的协议。
 * @param {array} items scc后台定义结构体的元素列表
 * @param {object} data scc后台定义结构体
 @param {boolean} disabled 所有组件是否设置为只读模式
 * @return {object} items 转换成form-create 要求的结构体

 */
//此数组包含不显示冒号的组件，用于过滤
var filterComponentArrayNoMH = ['groupLabel', 'anchorGo']
var filterComponentArrayNoDash = [
  'flashAddMedical',
  '_flashAddMedical',
  'flashAddMedicalForProduct',
  '_flashAddMedicalForProduct',
]
var filterComponentArrayConvertPadding = ['crudArray', 'crudArrayOrder', 'realPageTable']
createFormConverterUtil.converterItems = function (items, data, disabled, strategy) {
  if (!items) return items
  var curConpomentName = null // 用于记录当前的组件名称，便于做特殊处理
  for (var i = 0; i < items.length; i++) {
    var item = items[i]

    createFormConverterUtil.converterDataTypeDefinition(item, data, disabled)
    // console.log("converterItems", item.type);
    if (item.type && item.type.code) {
      // type.code是后端结构体
      item.typeCode = item.type.code
      item.type = null
    }
    if (item.component && item.component.code) item.type = item.component.code
    item.labelTip = item.title //字段提示文字
    if (item.label) item.title = item.label
    if (item.property) item.field = item.property
    if (item.validators) item.validate = item.validators

    if (!item.props) item.props = {}
    if (item.parameter) {
      item.options = item.parameter.options // 特殊处理
      item.props = item.parameter
    }

    if (disabled) {
      item.props.disabled = disabled
    }

    if (!item.field) {
      console.error('配置错误，property 不能为空')
    }
    // 给label后添加冒号
    if (filterComponentArrayNoMH.indexOf(item.type) === -1) {
      if (item.title && data && data.form && data.form.property && data.form.property.props) {
        if (
          data.form.property.props.labelPosition == 'right' ||
          data.form.property.props.labelPosition == 'left'
        ) {
          item.title += '：'
        }
      }
    }
    //设置显示组件格式，如金额等
    if (strategy) {
      converterUtil.formatConverterDetal(item, strategy)
    }

    // 特殊处理，如果crudArray组件的上一个组件是groupLabel，去掉crudArray组件上方的padding
    if (curConpomentName) {
      //如果是药械闪加，那么就把groupDash组件的高度去掉，把filterComponentArrayConvertPadding顶部高度改为5px
      if (
        filterComponentArrayNoDash.indexOf(curConpomentName) > -1 &&
        item.type.indexOf('groupDash') > -1
      ) {
        item.props['bottomHeight'] = '0'
      }
      if (
        curConpomentName.indexOf('groupDash') > -1 &&
        filterComponentArrayConvertPadding.indexOf(item.type) > -1
      ) {
        item.props['paddingTop'] = '10'
      }
    }

    if (item.type) {
      if (typeof item.type === 'object') curConpomentName = item.type.name || null
      if (typeof item.type === 'string') curConpomentName = item.type || null
    }

    /**
        隐藏标题的输入类型。目标时title控制了是否生成 FormItem 。
        目的不生成FormItem 强制换行。
        */
    if (createFormConverterUtil.HiddenTitleType.indexOf(item.type) > -1) {
      item.title = null
    }

    // 设置组件默认值，
    createFormConverterUtil.setDefaultValueOfItem(item)

    var converterAdapter = createFormConverterUtil.converterAdapter[item.type]
    if (typeof converterAdapter == 'function') converterAdapter(item, data)
    // 设置组件宽度
    if (item.typeCode) {
      var converterAdapterOfForStyle = createFormConverterUtil.converterAdapterOfForStyle.setWidth
      if (typeof converterAdapterOfForStyle == 'function') converterAdapterOfForStyle(item, data)
    }

    // if (item.type == 'groupLabel') {
    //   if (item.props && item.props.id) {
    //     var anchor = {
    //       "href": "#" + item.props.id,
    //       "title": item.props.title
    //     };
    //     if (data.anchorList) data.anchorList.push(anchor);
    //   }
    // }
  }

  return items
}

//

/**
 * 获取允许显示的组件列表
 * @param {array} items scc后台定义结构体的元素列表
 * @param {object} data scc后台定义结构体
 * @return {object} items 过滤后的组件列表
 */
createFormConverterUtil.getItemsForFilterVisible = function (items, data, vue) {
  var filterItems = []
  if (!items) return filterItems
  var propsCompileData = null
  for (var i = 0; i < items.length; i++) {
    var item = items[i]
    // 存在定义，并且为false，则认为不显示
    if (item.hasOwnProperty('visible') && item.visible === false) {
      continue
    }

    if (item.show) {
      if (!propsCompileData) {
        propsCompileData = compileVariableUtil.getCompileVariable({}, vue)
      }
      var propsCompile = templateUtil.compileData(item.show, propsCompileData)
      if (propsCompile == 'false' || !propsCompile) {
        continue
      }
    }

    filterItems.push(item)
  }

  return filterItems
}

//

/**
 * 设置组件默认值，
 * @param {array} items items 转换成form-create 要求的结构体
 */
createFormConverterUtil.setDefaultValueOfItem = function (item) {
  //默认设置未输入框
  if (!item.type) item.type = 'input'

  // var typeToLowerCase = item.type.toLowerCase();
  // //日期组件默认到秒
  // if (typeToLowerCase == 'datepicker') {
  //   if (!item.props) item.props = {};
  //   if (!item.props.format) item.props.format = "yyyy-MM-dd HH:mm:ss";
  // }

  //默认值都是字符串，根据数据类型进行转换。 后续处理
  // if(item.defaultValue){
  //     //数据类型
  //     if(item.type&&item.type.code){
  //
  //     }
  // }
}

/**
 * 获取表单Props配置参数，根据SCCscc后台定义结构体 转换
 * @param {object} data scc后台定义结构体
 @param {object} data 默认 Props配置参数
 * @return {object}  Props配置参数
 */
createFormConverterUtil.getCreateFormProps = function (form, defaultProps) {
  var props = defaultProps || {
    //是否开启行内表单模式
    inline: true,
    //表单域标签的位置，可选值为 left、right、top
    labelPosition: 'top',
    // //表单域标签的宽度，所有的 FormItem 都会继承 Form 组件的 label-width 的值
    //labelWidth: 0,
    //是否显示校验错误信息
    showMessage: true,
    //原生的 autocomplete 属性，可选值为 off 或 on
    autocomplete: 'off',
    // 表单的模板表达式控制
    parameter: null,
  }
  props.parameter = form ? form.parameter : null
  //form.property是后台协议（前端以后按此方式配置）
  if (form && form.property) {
    var property = form.property
    if (property.props) {
      props = Object.assign(props, property.props)
    }
    //这种不再使用
    if (form.property.colNumber) {
      if (form.property.colNumber == 1) {
        props.inline = false
        //props.labelPosition = "right";
        //  props.labelWidth = 150;
      } else {
        props.inline = true
      }
    }
  }
  //   console.log("getCreateFormProps", props);
  return props

  // var filterItems = []
  // if (!items) return filterItems
  // for (var i = 0; i < items.length; i++) {
  //   var item = items[i]
  //   //存在定义，并且为false，则认为不显示
  //   if (item.hasOwnProperty('visible') && item.visible === false) {
  //     continue
  //   }

  //   filterItems.push(item)
  // }

  // return filterItems
}
export default createFormConverterUtil
